import React from 'react';
import { translate } from '@utils/i18n';
import { TabView } from '@ui/molecules/TabView';
import GeneralSettings from './GeneralSettings';
import UserAccess from './UserAccess';
const namespace = 'features.settings.ai_inspection_manager';
function UserSettings({ settingsData, accounts, buildingTags, accountTags }) {
    const tabs = [
        {
            id: 'general',
            label: translate('general_tab', { namespace }),
            content: (React.createElement(GeneralSettings, { settingsData: settingsData, accounts: accounts, accountTags: accountTags, buildingTags: buildingTags }))
        },
        {
            id: 'user-access',
            label: translate('user_access_tab', { namespace }),
            content: React.createElement(UserAccess, { settingsData: settingsData })
        }
    ];
    return (React.createElement("section", { className: "ai-inspection-manager-settings__user-settings-section" },
        React.createElement(TabView, { tabs: tabs })));
}
export default UserSettings;
